import { useState } from 'react'
import Edit from './edit'

export default function Bookitem(props) {
    const { book, handleUpdateBook, handleAddJournal, filterJournals } = props
    const [displayPopup, setDisplayPopup] = useState(false)


    

    return <div>
        {displayPopup ? <Edit handleAddJournal={handleAddJournal}
            filterJournals={filterJournals}
            setDisplayPopup={setDisplayPopup}
            book={book}
            handleUpdateBook={handleUpdateBook} /> : <div></div>}
        <div className="cursor-pointer hover:bg-gray-200 transition-colors" onClick={() => setDisplayPopup(true)}>
            <div className="inline w-auto mr-7"> <span className="book-title">{book.name}</span> </div>
            <div className="inline w-auto mr-7"> <span className="font-light">@  Pg. {book.currentPage}</span> </div>
        </div>

    </div>
}